import DayJS from '../../../helpers/DayJS'
import FullLayout from '../../../layouts/FullLayout'
import HeaderBanner from '../../../components/DesignSystem/components/molecules/HeaderBanner/HeaderBanner.component'
import LoadingPage from '../../Other/LoadingPage'
import Styles from './Dashboard.module.css'
import { UserCoursesDTO } from '../../../apis/api.signup'
import { useCourses } from '../../../hooks/ApiHooks/useCourses'
import { useLocation } from 'wouter'
import { useTranslation } from 'react-i18next'

export const Dashboard = () => {
    const { t } = useTranslation(['teamDashboard'])
    const { courses, isLoading } = useCourses()

    if (isLoading) return <LoadingPage />

    return (
        <FullLayout page="dashboard">
            <div className="dashboard-grid-container container fill-gap">
                <HeaderBanner title={t('courses')} />
                <div className="teams-dashboard-container">
                    <div className="items-grid">
                        {courses?.map((item) => (
                            <CourseCard key={item.courseId} {...item} />
                        ))}
                    </div>
                </div>
            </div>
        </FullLayout>
    )
}

const CourseCard = ({ courseId, courseName, nextClass }: UserCoursesDTO) => {
    const [, setLocation] = useLocation()

    const goToCourse = () => setLocation(`/admin/overview/${courseId}/`)

    return (
        <div className={`egg-card ${Styles.card}`} onClick={goToCourse}>
            <h3 className={Styles.courseName}>{courseName}</h3>

            <NextClass {...nextClass} />
        </div>
    )
}

const NextClass = (nextClass: Partial<UserCoursesDTO['nextClass']>) => {
    const { t } = useTranslation(['teamDashboard'])

    if (!nextClass?.start)
        return (
            <p className="danger" style={{ fontSize: 14 }}>
                {t('No LIVE configured')}
            </p>
        )

    const { start, end } = nextClass
    const now = DayJS()

    if (now.isBetween(start, end))
        return (
            <p>
                <b className="success">LIVE</b> {t('until')} {DayJS(end).format('HH:mm[hs]')}
            </p>
        )

    return (
        <p>
            {t('Next')} <b className="success">LIVE</b> {now.to(start)}
        </p>
    )
}
